import navBarHomepage from '../modules/navbar-homepage';
import homepageAnalytics from '../modules/analytics/homepage';
import config from '../config';
import { pollManager } from '../modules/collection_poll';
let indexController = () => {
    require('../modules/inline-slideshow')();
    // require('../modules/article-video')();
    // require('../modules/floating-images')();
    // require('../modules/pie-chart-data')();
    // require('../modules/scrollback')();
    require('../modules/news_letter')();
    require('../modules/people-are-reading-animation')();
    navBarHomepage.on();
    homepageAnalytics();
    if (config.get('featureFlags.pollsEnabled') === true) {
        pollManager().init();
    }
};

export default indexController;
